module.exports = __webpack_public_path__ + "img/蜂蜜1.2d7c6068.png";